import { gql } from "@apollo/client";
export default gql`
  mutation GenerateEordersUrl($input: DelegationInputs!) {
    generateEordersUrl(input: $input)
  }
`;
